// import AudienceNavbar from "@/features/audiences/AudienceNavbar";
import { Audience } from "@/features/audiences/audience-types";
import { storageService } from "@/services/StorageService";
import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";

export default function AudiencePage() {
  const { audienceId } = useParams();
  const [audience, setAudience] = useState<Audience | undefined>(undefined);

  useEffect(() => {
    if (audienceId === undefined) {
      console.info("No audience id");
      return;
    }
    storageService.getAudienceById(audienceId).then(setAudience);
  }, [audienceId]);

  return (
    <>
      {audience && (
        <div className="">
          <p className="mb-4">Audience Definition:</p>
          {audience.freeTextDefinition}
          {/* <div className="flex-none w-48">
            <AudienceNavbar audience={audience} />
          </div> */}
          <div className="flex-1">
            {/* <h2 className="text-2xl font-bold mb-4">{audience.metadata.title}</h2> */}
            {/* <Outlet context={{ audience }} /> */}
          </div>
        </div>
      )}
    </>
  );
}
